import React, { useEffect, useState } from 'react';
import "./ReviewSummary.css";

function ReviewSummary({ hideHeader = false }) {
  const [summary, setSummary] = useState({ count: 0, average: 0 });
  const [reviews, setReviews] = useState([]);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    fetch("https://carcure.ca/backend/get-review-summary")
      .then((res) => res.json())
      .then((data) => setSummary(data))
      .catch((err) => console.error("Error fetching review summary:", err));

    if (hideHeader) {
      fetch("https://carcure.ca/backend/get-review-details")
        .then((res) => res.json())
        .then((data) => setReviews(data))
        .catch((err) => console.error("Error fetching review details:", err));
    }
  }, [hideHeader]);

  const handleToggleDetails = () => {
    if (!showDetails && !hideHeader) {
      fetch("https://carcure.ca/backend/get-review-details")
        .then((res) => res.json())
        .then((data) => setReviews(data))
        .catch((err) => console.error("Error fetching review details:", err));
    }
    setShowDetails((prev) => !prev);
  };

  const renderStars = (average) => {
    const fullStars = Math.floor(average);
    const halfStar = average - fullStars >= 0.5;
    const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);
    const stars = [];
    for (let i = 0; i < fullStars; i++) {
      stars.push(<span key={`full-${i}`} style={{ color: 'gold', fontSize: '16px' }}>★</span>);
    }
    if (halfStar) {
      stars.push(<span key="half" style={{ color: 'gold', fontSize: '16px' }}>☆</span>);
    }
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<span key={`empty-${i}`} style={{ color: 'gray', fontSize: '16px' }}>★</span>);
    }
    return stars;
  };

  const average = parseFloat(summary.average) || 0;

  return (
    <div className="review-summary">
      {!hideHeader && (
        <>
          <h3>Customer Reviews</h3>
          <p>
            Average Rating: {renderStars(average)} {average.toFixed(1)} ({summary.count})
          </p>
          <button onClick={handleToggleDetails} className="details-button">
            {showDetails ? "Hide Details" : "View Details"}
          </button>
        </>
      )}

      {(showDetails || hideHeader) && (
        <div className="review-details">
          {reviews.map((review, index) => (
            <div key={index} className="review-item">
              <p>
                <strong>{review.Name}</strong> rated <strong>{review["Average Rating"]}</strong> stars
              </p>
              {review.Comment && <p>{review.Comment}</p>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ReviewSummary;
